export const getSignedUpViaID = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const noteID = urlParams.get("noteID");
  const fromConfirmation = urlParams.get("fromConfirmation");
  const fromSystem = urlParams.get("fromSystem");
  const isFromSystem = fromSystem && parseInt(fromSystem) === 1;
  const isFromConfirmation =
    fromConfirmation && parseInt(fromConfirmation) === 1 && !isFromSystem;
  const pathName = window.location.pathname;

  if (noteID) return 1;
  if (pathName.includes("/signup/")) return 2;
  if (isFromSystem) return 3;
  if (isFromConfirmation) return 4;

  return null;
};
